import 'vuetify/styles'
import 'unfonts.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VBtn: {
      class: 'text-none',
    },
    VDialog: {
      'role': 'dialog',
      'class': 'rounded-lg',
      'scrim': 'rgba(0, 0, 0, 0.5)',
      'aria-modal': 'true',
      'width': 550,
      'maxWidth': '90vw',
      'variants': {
        'right-side-modal': {
          transition: 'slide-x-reverse-transition',
        },
        'left-side-modal': {
          transition: 'slide-x-transition',
        },
      },
      'VCard': {
        VCardTitle: {
          tag: 'h1',
          class: 'text-h5',
        },
      },
    },
    VToolbar: {
      style: 'top: 48px',
    },
  },
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme: {
        dark: false,
        colors: {
          'white': '#FFFFFF',
          'bankid': '#183E4F',
          'primary': '#0A0D0D',
          'brand-primary': '#00E2E2',
          'brand-secondary': '#E1FCFF',
          'secondary-light': '#FAFAFA',
          'neutral': '#9D9E9E',
          'success': '#4CAF50',
          'error': '#FF5252',
          'warning': '#FB8C00',
          'green-dark': '#006644',
          'green-main': '#00CC88',
          'green-light': '#E5F0EC',
          'grey-darkest': '#333333',
          'grey-dark': '#4D4D4D',
          'grey-main': '#999999',
          'grey-light': '#EFEFEF',
          'blue-dark': '#0052CC',
          'blue-main': '#3385FF',
          'blue-light': '#E5EDFA',
          'indigo-dark': '#002B99',
          'indigo-main': '#336DFF',
          'indigo-light': '#A9BDEF',
          'orange-dark': '#8A4600',
          'orange-main': '#FF8A11',
          'orange-light': '#FFE6CC',
          'red-dark': '#D10B23',
          'red-main': '#F53D53',
          'red-light': '#FEE9EC',
          'pink-dark': '#8C0D0D',
          'pink-main': '#F05B5B',
          'pink-light': '#EDABAB',
          'yellow-dark': '#974F0C',
          'yellow-main': '#ECC113',
          'yellow-light': '#FFF5CC',
          'white-dark': '#495057',
          'white-main': '#e9ecef',
          'white-light': '#f8f9fa',
        },
      },
    },
  },
})

export default vuetify
